<template>
  <div id="config-locations" class="basic-gray-section white f-h">
    <div class="f-h-below-title" style="padding:25px;box-sizing: border-box;">
      <Tree
        ref="tree"
        :items="allZones"
        :editable="true"
        @addItem="addZone"
        @nameEdited="zoneNameEdited"
        @parentChange="parentChanged"
        @deleteItem="deleteZone"
      />
      <button class="add-button italic" @click="addZone({ id: 0 })">
        <img src="/images/add.png" alt="add">
        {{ $t("message.ADD_A_LOCATION") }}
      </button>
    </div>
  </div>
</template>

<script>
/**
 * Config page to edit all the zone-related company-wide settings
 */

import { cloneDeep } from 'lodash';
import { mapState, mapActions } from 'vuex';
// Vuex utils
import { FETCH_ZONES, UPDATE_ZONE, CREATE_ZONE, DELETE_ZONE } from '@/store/action-types';
import { GET_ZONES } from '@/store/mutation-types';
// Components
import Tree from '@/components/tree.vue';
// Mixins
import mixinConfigPages from '@/mixins/config-pages.vue';
// Utils
import { calert, findTreeItemComponent, nestedFindItemWithId } from '@/utils/main';

export default {

  name: 'ConfigLocations',

  components: {
    Tree,
  },

  mixins: [mixinConfigPages],

  data() {
    return {
      company: {},
      allZones: [],
      // Properties used by other components. See src/views/readme.md
      pageTitle: this.$t('message.LOCATIONS'),
    };
  },

  computed: {
    ...mapState({
      zones: state => state[GET_ZONES.stateKey] || [],
      zonesLoading: state => state[GET_ZONES.loadingKey],
    }),
  },

  watch: {
    zones() {
      this.allZones = cloneDeep(this.zones);
    },
  },

  methods: {
    refresh() {
      if (!this.zonesLoading) {
        this.FETCH_ZONES();
      }
    },
    /** Triggered when a zone name has been modified */
    zoneNameEdited(zone) {
      this.UPDATE_ZONE({ id: zone.id, name: zone.name });
    },
    /** A zone's parent has changed */
    parentChanged(params) {
      if (params.id && params.parent) {
        const child = nestedFindItemWithId(this.allZones, params.id);
        this.UPDATE_ZONE({ ...child, parentZone: params.parent });
      }
    },
    addZone(parentZone) {
      this.CREATE_ZONE({ parentZone: parentZone.id }).then(() => {
        const parent = nestedFindItemWithId(this.allZones, parentZone.id);
        const zones = parentZone.id === 0
          ? this.allZones
          : parent.zones;
        this.$nextTick(() => {
          const zone = findTreeItemComponent(
            this.$refs.tree.$refs.children,
            zones[zones.length - 1],
          );
          zone.startEdit();
        });
      });
    },
    deleteZone(zone) {
      calert(this.$t('message.DELETE_SUBZONES'), [
        { title: this.$t('message.YES'), action: () => { this.confirmDeleteZone(zone, true); } },
        { title: this.$t('message.NO'), action: () => { this.confirmDeleteZone(zone, false); } },
        { title: this.$t('message.CANCEL') },
      ]);
    },
    confirmDeleteZone(zone, deleteChildren) {
      this.DELETE_ZONE({ id: zone.id, deleteChildren });
    },
    ...mapActions({
      FETCH_ZONES,
      UPDATE_ZONE,
      CREATE_ZONE,
      DELETE_ZONE,
    }),
  },
};
</script>

<style lang="scss">

#config-locations {
  .f-h-below-title {
    overflow: auto;

    > .add-button {
      margin-bottom: 70px;
    }
  }
  .add-button {
    padding: 10px;
  }
}
</style>
